import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('health-board', 'upload-document', [
  'START_UPLOAD',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'appointments',
    {
      type: 'payload',
      selector: ['appointmentId'],
    },
    'documents',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/upload-document-req.js